import { IBusStation } from "@/shared/types/busStaition";

/**
 * Адаптирует stops: Record<string, IBusStation> в массив IBusStation[],
 * нормализуя координаты (замена запятой на точку).
 */
export function adapterBusStaitions(
  busStaitions: Record<string, IBusStation>
): IBusStation[] {
  return Object.values(busStaitions).map((busStation) => ({
    ...busStation,
    stop_latitude: busStation.stop_latitude
      ? busStation.stop_latitude.toString().replace(",", ".")
      : undefined,
    stop_longitude: busStation.stop_longitude
      ? busStation.stop_longitude.toString().replace(",", ".")
      : undefined,
  }));
}